module.exports = __webpack_public_path__ + "img/logo_com_gorro_pb.7378bddf.png";